import { request } from './repository';

const url = 'source-situations/';


const sourceSituationStore = {
    getSourceSituations() {
        return request.get(url);
    },
    fetchOrganizationsBySourceSituation(source_situation_id) {
        return request.get(`source-situations/${source_situation_id}/organizations`);
    }
}

export default sourceSituationStore
